import {SERVICES} from './services';
import {mockUtil} from '@px/helper/moc';

const isMock = mockUtil.isMock();

export const API_URLS = {
  // user
  USER_LOGIN: '/users/login',
  USER_INFO: '/tokens/self',
  USER_LOGOUT: '/phemex-user/users/logout',
  USER_PREFERENCE: '/phemex-user/users/preference',
  PUBLIC_MISC: '/phemex-user/public/misc',
  USER_MEMBER_LEVEL: '/phemex-account/users/member/level',
  PUBLIC_GEO_V2: '/phemex-user/public/v2/geo',
  ACCOUNT_BIZ_GRAY: '/phemex-account/biz-gray',
  IM_ROBOT_INFO: '/phemex-im-server/public/data/zendesk/robot',

  CONFIG_PRODUCTS: '/public/products',
  CONFIG_PRODUCTS_PLUS: '/public/products-plus',

  USER_PROFILE_META: '/phemex-user/users/profile',

  // account
  ACCOUNT_TRANSFER: '/accounts/transfer',
  SUB_ACCOUNT_LIST: '/phemex-user/users/children',
  SUB_ACCOUNT_SWITCH: '/phemex-user/users/switch',
  MASTER_ACCOUNT_SWITCHBACK: '/phemex-user/users/switchBack',
  USER_TAG: '/phemex-client-data/users/tag/query',
  UPDATE_PROFILE: '/phemex-user/users/updateProfile',
  USER_CHILDREN: '/phemex-user/users/children',
  SWITCH_ACCOUNT: '/phemex-user/users/children/basic/info',
  ACCOUNT_TRANSFER_MAIN_SUB: '/exchanger-core/wallets/account/main-sub-transfer',
  CHILDREN_ASSETS: '/phemex-user/users/children/assets',
  CHILDREN_ASSETS_V2: '/phemex-user/users/v2/children/assets',
  CHILDREN_ASSETS_UTA: '/phemex-user/users/children/uta-assets',

  // order
  ORDER_LIMIT: '/orders',
  ORDER_MODIFY: '/orders',
  ORDER_CANCEL: '/orders',
  ORDER_CANCEL_ALL: '/orders/all',

  // new order
  G_ORDER: '/g-orders',
  G_ORDER_MODIFY: '/g-orders',
  G_ORDER_CANCEL: '/g-orders',
  G_ORDER_CANCEL_ALL: '/complex-orders/cancel-all',
  G_ORDERS_BASKET: '/g-orders/basket',
  G_ORDER_LIST: '/g-orders/create-order-list',

  // scaled order
  SCALED_ORDERS: '/orders/scaled',
  SCALED_G_ORDERS: '/g-orders/scaled',
  SCALED_PREVIEW: '/contract-biz/scaled/order/preview',

  // position
  POSITION_LEVERAGE: '/positions/leverage',
  POSITION_LEVERAGE_V2: '/g-positions/leverage',
  POSITION_RISK_LIMIT: '/positions/riskLimit',
  G_POSITION_RISK_LIMIT: '/g-positions/riskLimit',
  G_POSITION_SWITCH_POS_MODE: '/g-positions/switch-pos-mode-sync',
  G_POSITION_SWITCH_POS_MODE2: '/g-positions/batch-switch-pos-mode-sync',
  POSITION_CLOSE_ALL: '/complex-orders/close-all',

  POSITION_MARGIN_MODIFY: '/positions/assign',
  G_POSITION_MARGIN_MODIFY: '/g-positions/assign',
  POSITION_CLOSED_LIST: '/phemex-user/order/closedPositionList',
  //包含新合约的已平仓列表
  POSITION_CLOSED_LIST_V2: isMock ? '/phemex-user/mock/closedPositionList' : '/phemex-user/order/v2/closedPositionList',

  INDEX_QUOTE: '/phemex-user/margins/v2/quote',
  MARGIN: '/phemex-user/margins/v2',
  TRANSFER: '/exchanger-core/wallets/v3/transfer',
  TRANSFER_PILOT: '/exchanger-core/wallets/account/pilot/transfer',

  // kline
  KLINE: '/phemex-user/public/md/kline',
  KLINE_V2: '/phemex-user/public/md/v2/kline/list',
  TREND: '/phemex-user/public/md/v2/trend',

  CNT_COLLECTION: '/phemex-kol-global/public/agent/group/click',

  // kol
  ORDER_BOOK_PERM: '/orderbook/perm',
  ORDER_BOOK_ADJUST: '/orderbook/adjust ',

  // 公告
  ANNOUNCEMENTS_RECENT: '/phemex-user/public/announcements/recent',
  ACTIVITY_CONTENTS_VIEW_LOGOUT: '/phemex-activity/public/data/contents/list',
  ACTIVITY_CONTENTS_VIEW_LOGIN: '/phemex-activity/contents/list',
  BROWSE_TIME: '/phemex-activity/contents/browse-time',

  // tasks guide notify
  GET_TASKS: '/phemex-user/tasks/list',

  // KYC
  KYC_SUMMARY: '/phemex-kyc/kyc/summary',
  KYC_SUMMARY_ALL: '/phemex-kyc/kyc/summary-all',

  PROMOTIONS: '/phemex-user/public/promotions',

  // spot order
  SPOT_ORDER_CREATE: '/spot/orders',
  SPOT_ORDER_MODIFY: '/spot/orders',
  SPOT_ORDER_CANCEL: '/spot/orders',
  SPOT_ORDER_CANCEL_ALL: '/spot/orders/all',
  SPOT_ORDER_BASKET: '/spot/orders/basket',

  MEMBERSHIP_INFO: '/phemex-user/membership/baseMembershipInfo',
  RECEIVE: '/phemex-user/membership/drawMembershipFromPresent',
  BASE_MEMBER_INFO: '/phemex-user/membership/baseMembershipInfo',

  // Premium
  MEMBERSHIP_PURCHASE_PLANS: '/phemex-user/membership/view/membershipPurchasePlans',
  MEMBERSHIP_PURCHASE: '/phemex-user/membership/purchase',

  USER_KYC_INFO: '/phemex-user/membership/user-kyc-info',

  // coin Detail
  COIN_INFO: '/phemex-common-service/public/data/coin/info',
  PILOT_COIN_INFO: '/phemex-common-service/public/data/coin/pilot-info-list',
  COIN_DETAIL_LIST: '/phemex-activity/public/md/query/coin-list',

  // investment
  INVESTMENT_PRODUCT: '/phemex-wm/public/product/v2/on-sale',
  COIN_BASIC_LIST: isMock ? '/phemex-common-service/public/data/mock/coin/basic/list' : '/phemex-common-service/public/data/coin/basic/list',
  COIN_INFO_LIST: isMock ? '/phemex-common-service/public/data/mock/coin/info/list' : '/phemex-common-service/public/data/coin/info/list',
  TRADING_FEE_RATE: '/spot-wallet-assets/trading-fee-rate',
  MEMBER_IS_PREMIUM: '/phemex-user/users/member/is-premium',
  MEMBER_STAGE: '/phemex-user/users/public/member/stage',
  ABTEST: '/phemex-common-service/abtest',
  PRIVACY_COIN: '/phemex-user/public/compliance/privacy/coin',

  // earn
  EARN_CRYPTO_PRODUCT_LIST: '/phemex-wm/public/product/v3/on-sale',

  FAVORITES_LIST: '/phemex-user/users/favorites/list',
  //add or del favorite
  OPERATE_FAVORITE: '/phemex-user/users/favorites',
  OPERATE_FAVORITE_CONTRACT: '/phemex-user/users/favorites/contract',
  CONTRACT_OPERATE_FAVORITE: '/phemex-user/users/favorites/contract',
  FAVORITES_MERGE: '/phemex-user/users/favorites/merge',
  CHILDREN_BASIC_INFO: '/phemex-user/users/children/basic/info',
  CATEGORY_LIST: '/phemex-common-service/public/data/category/list',
  COPY_TRADE_ABTEST: '/phemex-lb/abtest',
  COPY_TRADE_TRADER_SETTING: '/phemex-lb/trader/copying-symbols',

  //basic-kyc
  KYC_COUNTRY_DOCUMENT_TYPES: '/phemex-kyc/kyc/base-kyc/support-document',
  KYC_BASIC_INFO: '/phemex-kyc/kyc/base-kyc/query',
  KYC_BASIC_SUBMIT: '/phemex-kyc/kyc/base-kyc/submit',
  BASE_KYC_CHECK: '/phemex-kyc/kyc/base-kyc/check',
  KYC_COUNTRIES: '/phemex-kyc/kyc/base-kyc/country-list',
  GET_BONUS: '/phemex-activity/general/public/val',

  WEB_RECOMMEND: '/phemex-predict/public/data/web/recommend',

  CUSTOMIZE_BIZ: '/contract-biz/cfg/customize/update',
  CUSTOMIZE_QUERY: '/contract-biz/cfg/customize/query',
  WELCOME_BONUS_AMOUNT: '/phemex-activity/public/data/welcome/amount',
  BONUS_WELCOME_DETAIL: '/phemex-activity/public/data/welcome/detail',
  MOCK_TRADING_TASK: '/phemex-activity/operation/task/list',
  MOCK_TRADING_TASK_SUBMIT: '/phemex-activity/operation/task/submit',

  // margin trade
  MARGIN_ACCOUNT_ACTIVATE: '/phemex-account/accounts/margin/open',
  MARGIN_BORROW: '/margin/borrow',
  MARGIN_REPAY: '/margin/payback',
  MARGIN_TRANSFER: '/exchanger-core/wallets/account/transfer',
  MARGIN_SYS_REMAINING_BORROW: '/margin-trade/wallets/query-firm-account',
  MARGIN_SYS_REMAINING_BORROW_UTA: '/uta/margin-trade/wallets/query-firm-account',
  COMMON_GRAY: '/phemex-user/biz-gray', // 灰度接口
  MT_WALLETS: '/margin/query-wallets',

  // margin trade order
  MARGIN_ORDER_CREATE: '/margin-trade/orders',
  MARGIN_ORDER_MODIFY: '/margin-trade/orders',
  MARGIN_ORDER_CANCEL: '/margin-trade/orders',
  MARGIN_ORDER_CANCEL_ALL: '/margin-trade/orders/all',

  // uta margin place order
  UTA_MARGIN_ORDER: '/uta/margin-trade/orders',
  UTA_MARGIN_ORDER_CANCEL_ALL: '/uta/margin-trade/orders/all',

  // Contract
  CONTRACT_TRANSFER_CURRENCIES: '/public/supported-currencies',

  // crypto-converter
  CONVERSION_SUPPORTED_CURRENCIES: '/exchanger-core/wallets/public/data/conversion/supported-currencies',
  //  双向合约灰度
  CONTRACT_GRAY: '/phemex-user/contract-gray',

  // Contract Biz 自定义
  CONTRACTBIZ_TPSLMODE_UPDATE: '/contract-biz/cfg/update-tpsl-mode',
  CONVERSION_QUOTE: '/exchanger-core/wallets/v3/conversion/quote', // 报价
  CONVERSION_WALLET: '/exchanger-core/wallets/v3/conversion', // 钱包covert
  CONVERSION_CONTRACT: '/exchanger-core/wallets/contract/transfer-convert-transfer', // 合约convert
  CONVERT_UTA: '/exchanger-core/wallets/universal/convert',

  //sensor dialog
  INNER_DIALOG: '/phemex-activity/dialog/available/list',
  INNER_DIALOG_TESTING: '/phemex-activity/dialog/tester/list',

  FIAT_BIZ_GARY: '/phemex-uni-trade/biz-gray', // 法币灰度
  //
  CONTRACT_TRADING_LIST: '/phemex-user/order/tradingList',
  CONTRACT_TRADING_LIST_V2: isMock ? '/phemex-user/mock/tradingList' : '/phemex-user/order/v2/tradingList',
  SPOT_TRADING_LIST: '/phemex-user/spot/order/trades',

  // strategy
  STRATEGY_AVAILABLE_SYMBOL: '/phemex-strategy/strategy/public/symbol-list',
  STRATEGY_CREATE_CONFIG: '/phemex-strategy/strategy/public/config-for-creation',
  STRATEGY_RECOMMEND_LIST: '/phemex-strategy/strategy/public/recommendation',
  STRATEGY_RECOMMEND_DETAIL: '/phemex-strategy/strategy/public/rec-params',
  STRATEGY_CREATE: '/phemex-strategy/strategy/create',
  STRATEGY_OPEN_LIST: '/phemex-strategy/strategy/my/all-open',
  STRATEGY_HISTORY_LIST: '/phemex-strategy/strategy/my/history',
  STRATEGY_INCREASE_BALANCE: '/phemex-strategy/strategy/increase-balance',
  STRATEGY_UPDATE_TPSL: '/phemex-strategy/strategy/adjust-tpsl',
  STRATEGY_UPDATE_TRIGGER: '/phemex-strategy/strategy/adjust-trigger',
  STRATEGY_START: '/phemex-strategy/strategy/start',
  STRATEGY_STOP: '/phemex-strategy/strategy/stop',
  STRATEGY_MARTIN_CREATE: '/phemex-strategy/strategy/martin/create',
  STRATEGY_MARTIN_RECOMMEND_LIST: '/phemex-strategy/strategy/public/data/martin/recommendation',
  STRATEGY_MARTIN_HISTORY_LIST: '/phemex-strategy/strategy/my/martin/history',
  STRATEGY_MARTIN_TPSL: '/phemex-strategy/strategy/martin/adjust-tpsl',
  STRATEGY_MARTIN_DETAIL: '/phemex-strategy/strategy/public/data/martin/rec-params',
  STRATEGY_MARTIN_UPDATE_STOP_CONDITION: '/phemex-strategy/strategy/update-stop-condition',
  STRATEGY_MARTIN_UPDATE_START_CONDITION: '/phemex-strategy/strategy/update-start-condition',
  STRATEGY_GRID_BACK_TEST: '/phemex-strategy/strategy/grid/backtest',
  STRATEGY_AIR_POS_TPSL_CANCEL: '/phemex-strategy/airdrop-position/order/cancel',
  STRATEGY_AIR_POS_TPSL_REPLACE: '/phemex-strategy/airdrop-position/order/replace',
  STRATEGY_AIR_POS_TPSL_CREATE: '/phemex-strategy/airdrop-position/order/close',

  // TradingView Signal Trade
  STRATEGY_SIGNAL_CREATE: '/phemex-strategy/signal/create',
  STRATEGY_SIGNAL_UPDATE: '/phemex-strategy/signal/update',
  STRATEGY_SIGNAL_DELETE: '/phemex-strategy/signal/del',
  STRATEGY_SIGNAL_DETAIL: '/phemex-strategy/signal/detail',
  STRATEGY_SIGNAL_LIST: '/phemex-strategy/signal/list',
  STRATEGY_SIGNAL_STRATEGY_CREATE: '/phemex-strategy/strategy/signal/create',
  STRATEGY_SIGNAL_STRATEGY_ADJUST_TPSL: '/phemex-strategy/strategy/signal/adjust-tpsl',
  STRATEGY_SIGNAL_STRATEGY_HISTORY: '/phemex-strategy/strategy/my/signal/history',

  SOUL_PASS_QUALIFICATIONS: '/phemex-account/soul-pass/qualifications',
  SOUL_PASS_STATUS: '/phemex-account/soul-pass/status',

  SPOT_STRATEGY_OPEN_LIST: '/spot-strategy/strategy/my/open',
  SPOT_STRATEGY_HISTORY_LIST: '/spot-strategy/strategy/my/history',
  SPOT_STRATEGY_CREATE: '/spot-strategy/strategy/create',
  SPOT_STRATEGY_START: '/spot-strategy/strategy/start',
  SPOT_STRATEGY_STOP: '/spot-strategy/strategy/stop',
  SPOT_STRATEGY_CONFIG: '/spot-strategy/strategy/public/data/config-for-creation',
  SPOT_STRATEGY_SYMBOL_LIST: '/spot-strategy/strategy/public/data/symbol-list',
  SPOT_STRATEGY_UPDATE_TPSL: '/spot-strategy/strategy/adjust-tpsl',
  SPOT_STRATEGY_UPDATE_TRIGGER_PRICE: '/spot-strategy/strategy/adjust-trigger',
  SPOT_STRATEGY_RECOMMEND_LIST: '/spot-strategy/strategy/public/data/recommendation',
  SPOT_STRATEGY_RECOMMEND_DETAIL: '/spot-strategy/strategy/public/data/rec-params',
  SPOT_STRATEGY_DETAIL_MAIN: '/spot-strategy/strategy/detail-main',

  VIP_PROFILE: '/phemex-account/users/vip/profile',
  VIP_FEE_CONFIG: '/phemex-account/public/data/users/fee-config',

  // 统一账户 账户相关
  UTA_QUERY: '/phemex-account/users/unified-account/query', // GET 查询用户统一保证金账户升级情况
  UTA_SPOT_UPGRADE_ANSWER_COMPLETED: '/phemex-account/users/unified-account/spot-upgrade/answer-completed', // POST 现货统一保证金账户升级答题完成
  UTA_SPOT_UPGRADE_APPLY: '/phemex-account/users/unified-account/spot-upgrade/apply', // POST 现货统一保证金账户升级提交(单个账户)
  UTA_SPOT_UPGRADE_CHECK_SUB: '/phemex-account/users/unified-account/spot-upgrade/check-sub', // GET 现货统一保证金账户子账户升级条件判断
  UTA_SPOT_UPGRADE_APPLY_SUB: '/phemex-account/users/unified-account/spot-upgrade/apply-sub', // POST 现货统一保证金账户升级提交（批量子账户）

  // pt 手续费
  SPOT_PT_DISCOUNT: '/margin/currency/discount',
  CONTRACT_PT_DISCOUNT: '/g-accounts/set-account-status',

  // Lending
  LENDING_ASSETS_OVERVIEW: '/phemex-lending/assets/overview',
  LENDING_POOL: '/phemex-lending/pool', // GET
  LENDING_PUBLIC_DATA_POOL: '/phemex-lending/public/data/pool', // GET

  // Assets data
  DATA_ASSETS_OVERVIEW: '/margin/assets/overview',

  // market
  MARKET_FAVORITE_GROUPS: '/phemex-account/users/favorite/group/query-all',
  MARKET_FAVORITE_GROUPS_ADD: '/phemex-account/users/favorite/group/add',
  MARKET_FAVORITE_GROUPS_DELETE: '/phemex-account/users/favorite/group/delete',
  MARKET_FAVORITE_GROUPS_RENAME: '/phemex-account/users/favorite/group/rename',
  MARKET_FAVORITE_INSTRUMENT_add: '/phemex-account/users/favorite/instrument/add',
  MARKET_FAVORITE_INSTRUMENT_DELETE: '/phemex-account/users/favorite/instrument/delete',
  MARKET_FAVORITE_INSTRUMENT_TOP: '/phemex-account/users/favorite/instrument/top',
  MARKET_FAVORITE_INSTRUMENT_SORT: '/phemex-account/users/favorite/instrument/sort',

  OC_FIAT_DEPOSIT_CONFIRM: '/phemex-uni-trade/fiat/event/receive/confirm',
  TRADE_DATA_POSITION_STATS: '/contract-biz/public/trading-data/position-stats',
  TRADE_DATA_FUNDING_FEE_STATS: '/contract-biz/public/trading-data/funding-fee-stats',

  NOTES_CREATE: '/contract-biz/notes/create',
  NOTES_UPDATE: '/contract-biz/notes/update',
  NOTES_DELETE: '/contract-biz/notes/delete',
  NOTES_LIST: '/contract-biz/notes/query-list',

  // 用户相关
  MEME_USE_ACCOUNT: '/phemex-meme/meme/user/account',
  MEME_USE_AGREEMENT: '/phemex-meme/meme/user/agreement',
  MEME_USE_FAVORITE: '/phemex-meme/meme/user/favorite',
  MEME_USE_ASSETS: '/phemex-meme/meme/user/assets',

  //币相关
  MEME_LIST: '/phemex-meme/meme/list',
  MEME_PUBLIC_LIST: '/phemex-meme/meme/public/data/list',
  MEME_THEMES: '/phemex-meme/meme/public/data/themes',
  MEME_DETAIL: '/phemex-meme/meme/detail',
  MEME_PUBLIC_DETAIL: '/phemex-meme/meme/public/data/detail',
  MEME_LIST_UPDATE: '/phemex-meme/meme/list/update',
  MEME_PUBLIC_LIST_UPDATE: '/phemex-meme/meme/public/md/update',
  MEME_CONFIG: '/phemex-meme/meme/config',
  MEME_PUBLIC_CONFIG: '/phemex-meme/meme/public/data/config',

  // 下单
  MEME_SWAP_QUOTE: '/phemex-meme/meme/swap/quote',
  MEME_SWAP: '/phemex-meme/meme/swap',

  //历史
  MEME_HISTORY: '/phemex-meme/meme/hist/orders',
};

Object.keys(API_URLS).forEach((key) => (API_URLS[key] = [SERVICES.API, API_URLS[key]].join('')));
